export const camadasDiagnostico = [
    'TERRA_INDIGENA',
    'TERRA_INDIGENA_PARAGUAI',
    'PASTIZAL_INUNDABLE_PARAGUAI',
    'PASTIZAL_PARAGUAI',
    'AREA_EMBARGADA',
    'PRODES',
    'MORATORIA_SOJA',
    'AREA_EMBARGADA_ICMBIO',
    'AREA_EMBARGADA_SEMA_MT',
    'AREA_EMBARGADA_GOIAS',
    'MORATORIA_SOJA_PONTOS',
    'LISTA_AREA_EMBARGADA',
    'PROTOCOLO_VERDE_GRAOS',
    'LISTA_SUJA_TRABALHO_ESCRAVO',
    'AMAZONIA_PROTEGE',
    'LDI',
    'UNIDADE_CONSERVACAO_US',
    'UNIDADE_CONSERVACAO_PI',
    'PRODES_CERRADO',
    'PRODES_PANTANAL',
    'PRODES_MATA_ATLANTICA',
    'PRODES_PAMPA',
    'PRODES_CAATINGA',
    'DETER_AMAZONIA',
    'DETER_CERRADO',
    'DESMATAMENTO_INFONA_PARAGUAI',
    'QUEIMADAS',
    'SITIOS_ARQUEOLOGICOS',
    'INCRA_ASSENTAMENTOS',
    'INCRA_QUILOMBOLAS',
    'QUILOMBOLAS_MARANHAO',
    'DESMATAMENTO_MAPBIOMAS',
    'AREA_RELEVANTE_INTERESSE_ECOLOGICO_ARIE',
    'AREA_PROTECAO_AMBIENTAL_APA',
    'APP',
    'RESERVA_LEGAL',
    'UNIDADE_CONSERVACAO',
    'POVOS_COMUNIDADES_TRADICIONAIS',
    'AREA_EMBARGADA_SEDAM_RO',
    'MORATORIA_SOJA_CONSOLIDADA',
    'LISTA_AREA_EMBARGADA_PIAUI',
    'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
    'AREA_EMBARGADA_PIAUI',
    'LISTA_AREA_EMBARGADA_SEMA_MT',
    'AREA_EMBARGADA_SIGA_MT_POLIGONO',
    'AREA_EMBARGADA_SIGA_MT_PONTO',
    'AREA_EMBARGADA_GDF',
    'FUNDACAO_PALMARES',
    'AUTO_INFRACAO_IPAAM',
    'TERMO_EMBARGO_IPAAM',
    'RED_FLAG',
    'YELLOW_FLAG',
    'AREA_EMBARGADA_PARANA',
    'AREA_EMBARGADA_AUTO_INFRACAO_SP',
    'FLORESTAS_PUBLICAS',
    'AREA_EMBARGADA_RS',
    'AREA_EMBARGADA_GO_PONTO',
    'AUTO_INFRACAO_TO',
    'AREAS_EMBARGADAS_TO',
    'EMBARGOS_GO_LISTA',
    'PRODES_RESIDUOS',
    'PRODES_RESIDUOS_AMAZONIA',
    'PRODES_RESIDUOS_CAATINGA',
    'PRODES_RESIDUOS_CERRADO',
    'PRODES_RESIDUOS_MATA_ATLANTICA',
    'PRODES_RESIDUOS_PAMPA',
    'PRODES_RESIDUOS_PANTANAL',
    'AUTO_INFRACAO_RS',
    'QUILOMBOLAS_BA',
    'CSA_CERRADO',
    'AREA_EMBARGADA_PA',
    'AUTO_INFRACAO_PI',
    'EUDR_FOREST_COVER_2020',
    'SITIO_RAMSAR_PARAGUAI',
    'RESERVA_BIOSFERA_PARAGUAI',
    'RESERVA_PROVINCIALE',
    'PRODES_2008',
    'PRODES_2009',
    'PRODES_2010',
    'PRODES_2011',
    'PRODES_2012',
    'PRODES_2013',
    'PRODES_2014',
    'PRODES_2015',
    'PRODES_2016',
    'PRODES_2017',
    'PRODES_2018',
    'PRODES_2019',
    'PRODES_2020',
    'PRODES_2021',
    'PRODES_2022',
    'PRODES_2023',
    'PRODES_2024',
    'AREA_PLANTADA_DESMATAMENTO_VEGA_A_PARTIR_2021'
];
